import React from 'react';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';

import { RovoTileIcon } from '../RovoTileIcon.tsx';

import { useShareContextRovoAction } from './useShareContextRovoAction.ts';

/** Not a message: product names are not translated, matching `SHARE_CONTEXT_TOOLS`. */
const ROVO_NAME = 'Rovo';

export type ShareContextRovoItemProps = {
	contentId?: string;
	/** Opens the host's own Rovo chat. Omitting it hides the item. */
	onAskRovo?: (prompt: string) => void;
};

/**
 * Rovo's item in the share-context menu: an in-page action, not a deep link. Renders nothing
 * when Rovo cannot be offered (see `useShareContextRovoAction`).
 */
export function ShareContextRovoItem({
	contentId,
	onAskRovo,
}: ShareContextRovoItemProps): React.JSX.Element | null {
	const askRovo = useShareContextRovoAction({ contentId, onAskRovo });

	if (!askRovo) {
		return null;
	}

	return (
		<DropdownItem
			elemBefore={<RovoTileIcon size="xsmall" />}
			onClick={askRovo}
			testId="share-context-menu-tool-rovo"
		>
			{ROVO_NAME}
		</DropdownItem>
	);
}
